import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';

import { ReportsService } from '../../services/reports.service';

import { ReportsConstants } from '../../reports.const';
import { Constants } from '../../../../app.const';

declare var $: any;

@Component({
  selector: 'app-resource-availability',
  templateUrl: './resource-availability.component.html'
})
export class ResourceAvailabilityComponent implements OnInit {

  date: string;
  originalData: any;
  filterData: any;
  expanded: boolean = false;
  multiple: boolean = true;
  available: boolean = false;
  typeSelected: Array<boolean> = [];
  projectTypeData: Array<any> = [];
  categorieId: any;
  isAll: boolean = true;
  skillsData: any;
  skillOptions: any;
  experience: any;

  formData: any = {};

  reportsConstants: any = ReportsConstants;
  private constants = Constants;
  constructor(
    private datePipe: DatePipe,
    private reportsService: ReportsService
  ) { }

  ngOnInit() {

    this.getFormData();

    let $this = this;
    let date = new Date();
    this.date = this.datePipe.transform(date, this.constants.dateFormat);
    $('.allocationDate').val(this.datePipe.transform(date, this.constants.dateFormat));
    $('.allocationDate').datepicker({
      autoclose: true,
      minViewMode: 0,
      format: this.constants.dateFormatDatepicker
    }).on('changeDate', function (selected) {
      let selectDate = new Date(selected.date.valueOf());
      $this.date = $this.datePipe.transform(selectDate, $this.constants.dateFormat);
      $this.getResourceAvailability();
    });
    this.getResourceAvailability();
  }

  filterResource() {
    this.filterData = this.skillsfilter();
    this.filterData = this.filterProjectType(this.filterData);
    this.filterData = this.experienceFilter(this.filterData);
    this.filterData = this.availableResourceFilter(this.filterData);
    this.filterData = this.sortByCurrentAvailability(this.filterData);
  }

  skillsfilter() {
    let resourceData = this.originalData.filter(data => {
      let skillResult = data.skills.filter(skill => {
        return this.skillsData && this.skillsData.indexOf(skill.id) !== -1;
      });
      return skillResult.length === this.skillsData.length
    });
    return resourceData;
  }

  filterProjectType(resourceData) {
    if (this.projectTypeData) {
      let expFiterResult = resourceData.filter(data => {
        let assignmentResult = data.assignments.filter(assignment => {
          !this.typeSelected[this.categorieId] && assignment.category_id === this.categorieId ? assignment['color'] = true : '';
          this.typeSelected[this.categorieId] && assignment.category_id === this.categorieId ? assignment['color'] = undefined : '';
          return assignment;
        });
        data.assignments = assignmentResult;
        return data;
      });
      return expFiterResult;
    } else {
      return resourceData;
    }
  }

  experienceFilter(resourceData) {
    if (this.experience) {
      let expFiterResult = resourceData.filter(data => {
        let skillResult = data.skills.filter(skill => {
          return (parseInt(this.experience) + 1) <= parseInt(skill.experience);
        });
        return skillResult.length > 0;
      });
      return expFiterResult;
    } else {
      return resourceData;
    }
  }

  availableResourceFilter(resourceData) {
    let availableResult = resourceData.filter(data => {
      return this.available && data.current_availability > 0
    });
    return this.available ? availableResult : resourceData;
  }

  sortByCurrentAvailability(resourceData) {
    resourceData.sort(function (a, b) {
      return (b.current_availability - a.current_availability);
    });
    return resourceData;
  }

  onSkillSelected(event) {
    this.filterResource();
  }

  onSkillDeselected(event) {
    this.filterResource();
  }

  onChangeExperience() {
    this.filterResource();
  }

  onSelectType(categorieId) {
    this.categorieId = categorieId;
    this.projectTypeData[categorieId] = categorieId;
    this.showCheckboxes();
    this.filterResource();
  }

  showCheckboxes() {
    this.expanded = !this.expanded ? true : false;
  }

  getResourceAvailability() {
    let body = { date: this.date }
    this.reportsService.getResourceAvailability(body).subscribe(
      res => {
        this.originalData = this.sortByCurrentAvailability(res.data);
        this.filterData = this.originalData;
      }
    );
  }

  getFormData() {
    this.reportsService.getResourceAvailabilityFormData().subscribe(
      res => {
        this.formData = res.data;
        let skills = [];
        this.formData && this.formData.skills.forEach(skill => {
          skills.push({ value: skill.id, label: skill.name });
        });
        this.skillOptions = skills;
        this.formData && this.formData.categories.forEach(categorie => {
          this.typeSelected[categorie.id] = true;
        });
        this.skillsData = 0;
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/reports/components/resource-availability/resource-availability.component.ts